import Vue from "vue";
import VueTouch from "vue-touch";
import App from "./app.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";

import "@/components";
import "@/filters/format-date";
import Ripple from "@/directives/ripple";

Vue.use(VueTouch);

Vue.directive("ripple", Ripple);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
